/* eslint-disable @typescript-eslint/unbound-method */
import { Component, Inject, PLATFORM_ID, type OnInit } from '@angular/core';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { CmsService } from '../../services/cms.service';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { Router, RouterModule } from '@angular/router';
import { isPlatformBrowser } from '@angular/common';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { UtilService } from '../../services/util.service';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { StorageService } from '../../services/storage.service';
import { StorageEnum } from '../../enums/storage.enum';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { PaymentService } from '../../services/payment.service';
import { AccountDetail } from '../../models/account-detail';
import { PaymentAccountType } from '../../enums/paymentaccounttype.enum';
import { SuccessData } from '../../models/success-data.model';
import { map } from 'rxjs';
import { Nav } from '../../enums/nav.enum';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { ErrorService } from '../../services/error.service';
import { EmailInfo } from '../../models/email-info';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { FormBuilder, Validators } from '@angular/forms';
import { emailValidator } from '../../validators/email.validator';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { AccountService } from '../../services/account.service';
import { EmailFormComponent } from '../email-form/email-form.component';
import { PageHeader } from '../../models/page-header.model';
import { PageHeaderComponent } from '../page-header/page-header.component';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { SeoService } from '../../services/seo.service';
import { NotificationComponent } from '../notification/notification.component';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { NotificationsService } from '../../services/notifications.service';
import { NotificationType } from '../../enums/notificationtype.enum';

@Component({
  selector: 'app-cancel-future-payment',
  imports: [
    MatButtonModule,
    MatDividerModule,
    EmailFormComponent,
    PageHeaderComponent,
    RouterModule,
    NotificationComponent,
  ],
  templateUrl: './cancel-future-payment.component.html',
  styleUrl: './cancel-future-payment.component.scss',
})
export class CancelFuturePaymentComponent implements OnInit {
  pageReady = false;
  pageLabels: any = {};
  isBrowser = false;
  data: any;
  accountDetail: AccountDetail = new AccountDetail();
  paymentErrors: any[] = [];
  emailFormData: any = {};
  hasEmail = false;
  formErrorMessage = '';
  headerData = new PageHeader();
  pageName = Nav.CancelFuturePayment;

  constructor(
    // eslint-disable-next-line @typescript-eslint/ban-types
    @Inject(PLATFORM_ID) readonly platformId: Object,
    private readonly cms: CmsService,
    private readonly router: Router,
    private readonly utils: UtilService,
    // eslint-disable-next-line @typescript-eslint/prefer-readonly
    private storage: StorageService,
    private readonly payment: PaymentService,
    private readonly error: ErrorService,
    private readonly fb: FormBuilder,
    private readonly account: AccountService,
    private readonly seoS: SeoService,
    private readonly notifi: NotificationsService,
  ) {
    this.isBrowser = isPlatformBrowser(platformId);
    if (this.isBrowser) {
      this.accountDetail = this.storage.getSession(StorageEnum.AccountDetail);
      this.paymentErrors = this.storage.getSession(StorageEnum.GlobalVars).paymentErrors;
    }
  }

  ngOnInit(): void {
    this.cms
      .getContent('oas-payment', 'Payment')
      .pipe(
        map((data) => {
          const labelList: any = [];
          const dataCopy = JSON.parse(JSON.stringify(data));
          // here is a comment that can be removed in the future

          data.paymentSuccessLabelsList.forEach((label: any) => {
            labelList.push({ name: label.labels.value.name, data: label.labels.value.data });
          });
          dataCopy.paymentSuccessLabelsList = labelList;
          return dataCopy;
        }),
      )
      .subscribe((data) => {
        this.pageLabels = data;
        this.headerData.Message = this.pageLabels.cancelFuturePaymentPageHeaderText;
        this.seoS.setSeoTags(data.seo);
        if (this.isBrowser) {
          this.setSuccessData();
          this.hasEmail =
            this.accountDetail?.Person?.EmailAddresses?.find((email: EmailInfo) => {
              return email.IsPrimary && email.Type?.toUpperCase() === 'EMAIL';
            })?.IsPrimary ?? false;
          if (!this.hasEmail) {
            this.setupEmailData();
          }
          this.pageReady = true;
          this.utils.hideSpinner();
        }
      });
  }

  setSuccessData(): void {
    const successLabels = this.pageLabels.paymentSuccessLabelsList.find((labels: any) => {
      return labels.name === 'CancelFuturePaySuccess';
    }).data;
    const success = new SuccessData();
    success.Header = successLabels.header;

    success.Details.push({
      Label: successLabels.details[0].detailLabel,
      Value: `${this.accountDetail?.FuturePayment?.Info?.PaymentDate?.toString()}`,
    });
    success.Details.push({
      Label: successLabels.details[1].detailLabel,
      Value: `$ ${this.accountDetail?.FuturePayment?.Info?.PaymentAmount}`,
    });
    if (
      this.accountDetail?.FuturePayment?.PaymentMethod?.Type === PaymentAccountType.ApplePay.toString() ||
      this.accountDetail?.FuturePayment?.PaymentMethod?.Type === PaymentAccountType.GooglePay.toString() ||
      this.accountDetail?.FuturePayment?.PaymentMethod?.Type === PaymentAccountType.PayPal.toString() ||
      this.accountDetail?.FuturePayment?.PaymentMethod?.Type === PaymentAccountType.Venmo.toString()
    ) {
      success.Details.push({
        Label: successLabels.details[2].detailLabel,
        Value: this.accountDetail?.FuturePayment?.PaymentMethod?.Type,
      });
    } else {
      success.Details.push({
        Label: successLabels.details[2].detailLabel,
        Value: this.payment.getPaymethodDescription(
          this.accountDetail.FuturePayment?.PaymentMethod?.Type as PaymentAccountType,
          this.accountDetail?.FuturePayment?.PaymentMethod?.AccountNumber,
        ),
      });
    }

    success.CTAList.push({
      Label: successLabels.ctaList[0].ctaLabel,
      Link: successLabels.ctaList[0].ctaUrl,
      AriaLabel: successLabels.ctaList[0].ctaAriaLabel,
    });

    this.storage.setSession(StorageEnum.SuccessData, success);
    this.data = success;
  }

  cancelFuturePayment(): void {
    this.utils.showSpinner();
    const futurePayment = this.payment.buildCancelFutureDatePaymentRequest(this.accountDetail);
    if (!this.hasEmail) {
      // handle new email stuff
      // according to ticket, even if this call fails we continue with payment, so we don't really need to do anything with the response
      if (this.emailFormData.formGroup.valid) {
        const emailValue = this.emailFormData.formGroup.value.email;

        const personRequest = this.accountDetail?.Person;
        const email = new EmailInfo();
        email.ContactId = '';
        email.Email = emailValue;
        email.IsActive = true;
        email.IsPrimary = true;
        email.Type = 'EMAIL';
        personRequest?.EmailAddresses?.push(email);
        this.account.UpdatePersonContact(personRequest).subscribe({
          error: (e) => {
            this.utils.consoleLog('There was an error adding email on payments page. Error: ' + e);
          },
          next: (data: any) => {
            this.accountDetail.Person = data;
            this.storage.setSession(StorageEnum.AccountDetail, this.accountDetail);
            this.hasEmail = true;
          },
        });
      } else {
        const errorMessage = this.storage.getSession(StorageEnum.GlobalVars).formError;
        this.emailFormData.formGroup.markAllAsTouched();
        this.showFormErrorLabel(errorMessage);
        this.utils.hideSpinner();
        return;
      }
    }

    this.payment.postFuturePayment(futurePayment).subscribe({
      error: (e) => {
        this.setErrorData(e.message);
        void this.router.navigateByUrl(Nav.ErrorPage);
      },
      next: (data: any) => {
        this.utils.hideSpinner();
        void this.router.navigateByUrl(Nav.CancelFuturePaymentSuccess);
      },
    });
  }

  setErrorData(errorCode: string): void {
    this.error.setErrorData(errorCode, this.pageLabels.cancelFuturePaymentError);
  }

  setupEmailData(): void {
    this.emailFormData.showConfirmEmail = true;
    this.emailFormData.formGroup = this.fb.group({
      email: ['', [Validators.required, emailValidator()]],
      emailConfirm: ['', [Validators.required, emailValidator()]],
    });
  }

  showFormErrorLabel(errorMessage: string): void {
    this.formErrorMessage = errorMessage;
    if (this.formErrorMessage && this.formErrorMessage !== '') {
      this.notifi.clearAllNotifications(this.pageName);
      this.notifi.addNotification(this.formErrorMessage, NotificationType.Error, this.pageName);
    }
  }
}
